const routes = {
  companyId: "/:companyId",
  userId: "/:userId",
  auth: "/accounts",
  changepassword: "/change_password",
  needHelp: "/need_help",
  accountInfo: "/my_account",
  viewActions: "/view_actions",
  companies: "/companies",
  campaign: "/campaign",
  portfolio: "/portfolio",
  adminStaff: "/admin_staff",
  weeklyBusinessReview: "/weekly_business_review",
  dashProject: "/project",
  notfound: "/not_found",
  paymentSuccess: "/payments/success",
  paymentFailure: "/payments/failed",
  home: "/home",
  admin: "/admin",
  clientfiles: "/client",
  dashboard: "/dashboard",
  notification: "/notification",
  executivesummary: "/executive",
  startData: "/start",
  dataPull: "/data_pull",
  todolist: "/to_do_list",
  poRtodolist: "/to_do_list/po_report",
  actiontodolist: "/action",
  recommendation:"recommendation",
  contentAudit: "/content_audit",
  dash: "/dash",
  approvaltodolist: "/approvals",
  poRecommendation: "/po_recommendation",
  poHistory: "/po_history",
  userinputs: "/settings",
  customLabelling: "/custom_labelling",
  authorizations: "/authorizations",
  strategicInput: "/strategic",
  manageProduct: "/manage_product",
  amazonReports: "/amazon_reports",
  manageuser: "/users",
  reportsnew: "/v2_reports",
  reports: "/reports",
  r2system:'/r2_system',
  reportsSales: "/sales",
  reportsSalesGNR: "/gross_net_revenue",
  reportsPayments: "/payments",
  reportsSalesPOR: "/purchase_order_revenue",
  reportsSalesCOR: "/consumer_order_revenue",
  reportsSalesGBDDBasic:"/geography_breakdown_ddbasic",
  reportsSalesGB: "/geography_breakdown",
  reportsSalesRBDDBasic:"/revenue_breakdown_ddbasic",
  reportsSalesRB: "/revenue_breakdown",
  reportsSalesPBI1: "/report1",
  reportsSalesPBI2: "/report2",
  reportsSalesPBI3: "/amsSummary",
  reportsSalesPBI4: "/amsCampaign",
  reportsSalesASINDDBasic: "/asin_deep_dive_ddbasic",
  reportsSalesASIN: "/ASIN",
  reportsMarketing: "/marketing",
  reportsMarketingSRDDBasic: "/search_ranking_ddbasic",
  reportsMarketingSR: "/search_ranking",
  reportsMarketingCEDDBasic:"/customer_engagement_ddbasic",
  reportsMarketingCE: "/customer_engagement",
  reportsMarketingADDDBasic:"/advertising_ddbasic",
  reportsMarketingNCEDDBasic:"/new_customer_engagement_ddbasic",
  reportsMarketingAD: "/advertising",
  reportsMarketingPR: "/promotions",
  reportsOperations: "/operations",
  reportsOperationsSCPDDBasic: "/supply_chain_performance_ddbasic",
  reportsOperationsSCP: "/supply_chain_performance",
  reportsOperationsSP: "/seller_performance",
  reportsOperationsPOR: "/po_recommendations",
  reportsOperationsPOF: "/po_forecast",
  reportsOperationsGBDDBasic: "/geography_breakdown_ddbasic",
  reportsOperationsGB: "/geography_breakdown",
  reportsOperationsIAF: "/inventory_and_forecast",
  reportsFinance: "/finance",
  reportsSalesGNRDDBasic:'/gross_net_revenue_ddbasic',
  reportsFinanceGNR: "/gross_net_revenue",
  reportsFinanceCOB: "/cost_of_business",
  reportsFinanceIAF: "/inventory_and_forecast",
  reportsFinanceASIN: "/ASIN",
  reportsFinancePOCOR: "/consumer_order_revenue",
  reportsFinanceASP: "/asp_tracking",
  reportsFinanceCost: "/cost_of_business",
  reportsForTesting: "/testing",
};

routes.authLogin = `${routes.auth}/login`;
routes.authRegister = `${routes.auth}/login`;
routes.authVerify = `${routes.auth}/verify`;
routes.authSubscription = `${routes.auth}/subscription`;
routes.authForgot = `${routes.auth}/forgot_password`;

export default routes;
